/**
 * @file SessionTurns.ts
 * @brief Sessions' own icon: a conversation, turn by turn (was lucide List / Activity).
 *
 * @details
 * Mirrors the mobile app's `FRONTEND/src/shared/components/icons/SessionTurns.ts`
 * (DES 08-10-2026, app-specific icons): identical geometry and keys, built
 * with lucide-react's `createLucideIcon` so it takes the same props
 * (size, className, strokeWidth, color) as every lucide icon.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const SessionTurns = createLucideIcon("SessionTurns", [
  ["rect", { x: "3", y: "3", width: "13", height: "3.5", rx: "1.75", key: "turn-1" }],
  ["rect", { x: "8", y: "10.25", width: "13", height: "3.5", rx: "1.75", key: "turn-2" }],
  ["rect", { x: "3", y: "17.5", width: "13", height: "3.5", rx: "1.75", key: "turn-3" }],
]);

export default SessionTurns;
